export enum CatalogueState {
    ARCHIVE = 'ARCHIVE',
    LIVE = 'LIVE',
    OPEN = 'OPEN',
}
